// Puerto de packages/hce/src/config.ts, adaptado al Módulo Proxy
// (Rediseño mayor 2026-08-31): el navegador nunca habla directo con
// Medplum — `baseUrl` de MedplumClient apunta al proxy transparente de la
// bóveda (`/api/hce/medplum/*`, ver medplum-proxy.ts en packages/web), no
// a la URL real de Medplum. `MEDPLUM_BASE_URL` ya no se lee acá a
// propósito: si algún día vuelve a hacer falta un valor separado del de
// la bóveda, agregarlo explícito, no reintroducir el env var viejo sin
// pensarlo.
export interface HceChartConfig {
  baseUrl?: string;
  clientId?: string;
  /**
   * URL de la bóveda (consent-vault) — para /api/hce/audit (auditedFetch.ts),
   * /api/hce/dictado (BotonDictado.tsx), y ahora también el proxy de Medplum.
   */
  vaultUrl?: string;
}

const vaultUrl: string | undefined = import.meta.env?.MEDPLUM_APP_VAULT_URL;

const config: HceChartConfig = {
  baseUrl: vaultUrl ? `${vaultUrl.replace(/\/+$/, '')}/api/hce/medplum/` : undefined,
  clientId: import.meta.env?.MEDPLUM_CLIENT_ID,
  vaultUrl,
};

export function getConfig(): HceChartConfig {
  return config;
}
